export const LotusLogo = ({ size = 40, className = "", testId = "lotus-logo" }) => (
  <img
    src="/icon-512.png"
    width={size}
    height={size}
    alt="Holistic Healing Psychotherapy lotus emblem"
    data-testid={testId}
    className={`rounded-[22%] shrink-0 ${className}`}
  />
);

export default LotusLogo;
